import { ReactElement } from 'react';
import {
  ArrowRightIcon,
  BuildingOffice2Icon,
  UserIcon,
} from '@heroicons/react/24/outline';
import { Button, Input } from '@sc/shared-ui';
import { useForm } from '@tanstack/react-form';

export interface AccountDetailsInterface {
  fullName: string;
  companyName: string;
}

interface Props {
  defaultValues: AccountDetailsInterface;
  onSubmit: (values: AccountDetailsInterface) => Promise<void>;
  loading?: boolean | undefined;
}

export const AccountDetailsForm = ({
  defaultValues,
  onSubmit,
  loading,
}: Props): ReactElement => {
  const form = useForm({
    defaultValues,
    onSubmit: async ({ value }) => onSubmit(value),
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        e.stopPropagation();

        void form.handleSubmit();
      }}
      className="w-full space-y-5"
    >
      <form.Field
        name="fullName"
        validators={{
          onSubmit: (state) => {
            const split = state.value.trim().split(' ');

            if (split.length < 2) return 'Please enter full name';

            return undefined;
          },
        }}
        children={(field) => (
          <Input
            value={field.state.value}
            error={field.state.meta.errors.join(', ')}
            label="Full name"
            required
            Icon={UserIcon}
            onChange={(e) => field.handleChange(e.target.value)}
          />
        )}
      />

      <form.Field
        name="companyName"
        children={(field) => (
          <Input
            value={field.state.value}
            label="Company"
            type="text"
            required
            Icon={BuildingOffice2Icon}
            onChange={(e) => field.handleChange(e.target.value)}
          />
        )}
      />

      <Button
        button={{
          isSubmit: true,
          text: 'Continue',
          IconEnd: ArrowRightIcon,
          type: 'primary',
          size: 'large',
          loading,
          disabled: loading,
        }}
      />
    </form>
  );
};
